export const auditFacts = {
  // AuditFact.id names the identity, and every version of an identity shares
  // it, so a superseded-versions page holds several facts with one id.
  // Normalizing by id would collapse them into one. Each fact stays inline in
  // the page that returned it.
  AuditFact: {
    keyFields: false as const,
  },
  // AuditFactEdge.id names the fact at the other end. Two edges of different
  // types can point at the same fact, so the id is not the edge's identity.
  AuditFactEdge: {
    keyFields: false as const,
  },
  // AuditFactDetail carries every version and one page of each version's
  // objects. The objects page merges in Query.readAuditFact, which needs the
  // detail inline rather than behind a reference.
  AuditFactDetail: {
    keyFields: false as const,
  },
}
